import React from 'react';
import { Helmet } from 'react-helmet';
import { useLocation } from '@reach/router';
import { webSite, webPage, breadcrumbForPath } from '@helpers/schema';

const StructuredData = ({ schema }) => {
    const location = useLocation();
    const pathname = location?.pathname || '/';

    const pageSchemas = (Array.isArray(schema) ? schema : [schema]).filter(Boolean);

    const siteWideSchemas = [
        webSite(),
        webPage({ pathname }),
        breadcrumbForPath(pathname),
    ];

    const allSchemas = [...siteWideSchemas, ...pageSchemas];

    const payload = {
        '@context': 'https://schema.org',
        '@graph': allSchemas.map(({ '@context': _ctx, ...rest }) => rest),
    };

    return (
        <Helmet>
            <script type="application/ld+json">{JSON.stringify(payload)}</script>
        </Helmet>
    );
};

export default StructuredData;
